import { createModel, RematchDispatch } from '@rematch/core';
import produce from 'immer';

import baseEntity from './base.entity';
import { storeName as projectChildItemEntity } from './projectChildItem.entity';
import { RootModel } from '../models';
import { storeName as layoutModelStore } from '../models/layout.model';
import { ProjectChildItemTypes } from '../../types';
import { convertSimplifiedProjectChildItemResponse } from '../../utils';
import { SimplifiedProjectChildItemResponseTypes } from '../../types/response';
import { getPromotionsData } from '../../services/projectItem.service';

export const storeName = 'sitePlanPromotionsEntity';

export const sitePlanPromotionsEntity = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
    saveIds: produce((state, params) => {
      const { sitePlanId, promotionIds } = params;
      state.ids[sitePlanId] = promotionIds;
    }),
  },
  effects: (dispatch: RematchDispatch<typeof sitePlanPromotionsEntity>) => ({
    async loadPromotions(payload, state) {
      const { id, code } = payload;
      const { locale } = state[layoutModelStore];

      let promotions = [];
      let promotionIds = state[storeName].ids[id];
      const projectChildItem = state[projectChildItemEntity].ids;

      if (promotionIds) {
        promotions = promotionIds.map((promotionsId: number) => projectChildItem[promotionsId]);
      } else {
        // Get, convert and save promotions list
        const res = await getPromotionsData(code, locale.apiLanguage);
        promotions = res.map((v: SimplifiedProjectChildItemResponseTypes) => {
          return convertSimplifiedProjectChildItemResponse(v);
        });
        dispatch[projectChildItemEntity].saves(promotions);

        // Parse and save ids number list
        promotionIds = promotions.map((v: ProjectChildItemTypes) => v.id);
        this.saveIds({ sitePlanId: id, promotionIds });
      }
    },
  }),
});

export default sitePlanPromotionsEntity;
